// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1T__o","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3AjM5"};